import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { Menu, X } from 'lucide-react';
import logo from "@/assets/logo.jpeg";

export default function Header({ mobileMenuOpen, setMobileMenuOpen }) {
    const [scrolled, setScrolled] = useState(false);
    const navRef = useRef(null);

    // Scroll effect for header
    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setMobileMenuOpen(false);
            }
        };
        if (mobileMenuOpen) document.addEventListener("mousedown", handleClickOutside);
        else document.removeEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [mobileMenuOpen, setMobileMenuOpen]);

    // Prevent scrolling when menu is open
    useEffect(() => {
        document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
    }, [mobileMenuOpen]);

    return (
        <header className={`main-header ${scrolled ? 'scrolled' : ''}`}>
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="logo flex flex-row gap-3" data-testid="header-logo">
                        <div>
                            <img src={logo} className="max-h-10 rounded-full" />
                        </div>
                        <div className="logo-text">
                            Laxmi Finsec Consultant
                            <div className="logo-subtext">Pvt. Ltd.</div>
                        </div>
                    </Link>

                    {/* Overlay for mobile menu */}
                    {mobileMenuOpen && (
                        <div
                            className="mobile-menu-overlay"
                            onClick={() => setMobileMenuOpen(false)}
                        />
                    )}

                    <nav ref={navRef} className={`main-nav ${mobileMenuOpen ? 'open' : ''}`}>
                        <Link to="/" data-testid="nav-home">Home</Link>
                        <Link to="/about" data-testid="nav-about">About Us</Link>
                        <a href="#services" data-testid="nav-services">Services</a>
                        <Link to="/contact" data-testid="nav-contact">Contact</Link>
                        <a href="#emi-calculator" className="btn-emi" data-testid="nav-emi">EMI Calculator</a>
                    </nav>

                    <button
                        className="mobile-menu-btn"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        data-testid="mobile-menu-toggle"
                    >
                        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Styles for overlay */}
            <style>{`
        .mobile-menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0,0,0,0.5);
          z-index: 998;
        }

        .main-nav.open {
          position: fixed;
          top: 0;
          right: 0;
          width: 75%;
          max-width: 300px;
          height: 100vh;
          background: white;
          flex-direction: column;
          padding: 2rem;
          z-index: 999;
          transform: translateX(0);
          transition: transform 0.3s ease;
        }

        .main-nav {
          transform: translateX(100%);
          transition: transform 0.3s ease;
        }

        @media (min-width: 768px) {
          .main-nav {
            transform: none;
            position: static;
            flex-direction: row;
            height: auto;
            background: none;
          }
          .mobile-menu-btn {
            display: none;
          }
          .mobile-menu-overlay {
            display: none;
          }
        }
      `}</style>
        </header>
    );
}
